<template>
  <section>
    <PageTitle title="Twoja kariera w naszej firmie" />
    <div
      class="container px-4 pt-12 mx-auto text-center sm:px-0 lg:px-0 xl:px-0 2xl:px-64 md:pt-40 lg:pt-40 2xl:pt-56 sm:text-left"
    >
      <main>
        <div class="text-gray-700 body-font">
          <div class="flex flex-col w-full px-5 py-12">
            <div class="lg:w-full">
              <div class="h-64 overflow-hidden hidden rounded-lg">
                <img
                  alt="content"
                  class="object-cover object-center w-full h-full"
                  src="https://dummyimage.com/1200x500/cbd5e0"
                />
              </div>
              <div class="flex flex-col mt-10 sm:flex-row">
                <div class="text-center sm:w-1/3 sm:pr-8 sm:py-8">
                  <div class="inline-flex items-center justify-center w-20 h-20 text-gray-400 bg-gray-200 rounded-full">
                    <svg
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      class="w-10 h-10"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                  </div>
                  <div class="flex flex-col items-center justify-center text-center">
                    <h2 class="mt-4 text-lg font-medium text-gray-900 title-font">Pomoc hafciarza</h2>
                    <div class="w-12 h-1 mt-2 mb-4 bg-blue-500 rounded"></div>
                    <p class="text-base text-gray-600"></p>
                  </div>
                </div>
                <div
                  class="pt-4 mt-4 text-center border-t border-gray-300 sm:w-2/3 sm:pl-8 sm:py-8 sm:border-l sm:border-t-0 sm:mt-0 sm:text-left"
                >
                  <p class="mb-4 text-lg font-bold leading-relaxed">Miejsce pracy: Baranowo Opis stanowiska:</p>

                  <ul class="pl-6 list-disc list-inside">
                    <li>Obsługa przemysłowej maszyny hafciarskiej</li>
                    <li>Dbanie o zachowanie standardów jakościowych i efektywnościowych</li>
                    <li>Dbanie o ład i porządek na stanowisku pracy</li>
                  </ul>
                  <p class="my-4 text-lg font-bold leading-relaxed">Wymagania:</p>
                  <ul class="pl-6 list-disc list-inside">
                    <li>Zaangażowanie i odpowiedzialność za powierzoną część produkcji</li>
                    <li>Dyspozycyjność w pracy zmianowej</li>
                    <li>Podstawowa znajomość obsługi komputera</li>
                    <li>Mile widziane doświadczenie w branży hafciarskiej</li>
                  </ul>
                  <p class="my-4 text-lg font-bold leading-relaxed">Oferujemy:</p>
                  <ul class="pl-6 list-disc list-inside">
                    <li>Możliwość przyuczenia do stanowiska pracy</li>
                    <li>Stabilność zatrudnienia</li>
                    <li>
                      Atrakcyjne warunki zatrudnienia uzależnione od doświadczenia i posiadanych umiejętności
                    </li>
                    <li>Miłą atmosferę pracy</li>
                  </ul>

                  <!-- <a class="inline-flex items-center mt-5 text-blue-500"
                  >Dowiedz się więcej
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    class="w-4 h-4 ml-2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7"></path>
                  </svg>
                  </a>-->
                </div>
              </div>
            </div>
            <div class="mt-5 row">
              <p class="py-5">
                Osoby zainteresowane prosimy o kontakt telefoniczny
                <a class="text-blue-500" href="tel:48609020455">609 020 455</a> lub przesyłanie CV na adres e-mail
                <a class="text-blue-500" href="mailto:biuro@haft-poznan.pl">biuro@haft-poznan.pl</a>. Prosimy o wpisanie
                w temacie maila słów „Rekrutacja – Haft”. Równocześnie zastrzegamy sobie prawo odpowiedzi wyłącznie na
                wybrane oferty.
              </p>
              <p class="py-5">
                <span class="font-bold">Wszystkie przesłane oferty powinny zawierać klauzulę:</span>
                „Wyrażam zgodę na przetwarzanie przez Firma P. Woźny Anna Woźna w Poznaniu moich danych osobowych, które
                zostały zamieszczone w przekazanych przeze mnie dokumentach (CV, życiorys, list motywacyjny) w celu
                przeprowadzenia procesu rekrutacji, zgodnie z rozporządzeniem UE 2016/679 z dnia 27.04.2016 r). Zostałem
                poinformowany, że zgoda może zostać wycofana w dowolnym momencie”.
              </p>
              <p class="py-5">
                <span class="font-bold">
                  Jeżeli chcesz, abyśmy zachowali Twoje CV w naszej bazie, umieść dodatkowo w CV następującą zgodę: </span
                >„Zgadzam się na przetwarzanie przez Firma P. Woźny Anna Woźna w Poznaniu danych osobowych zawartych w
                moim zgłoszeniu rekrutacyjnym także dla celów przyszłych rekrutacji prowadzonych Firma P. Woźny Anna
                Woźna w Poznaniu. Zostałem poinformowany, że zgoda może zostać wycofana w dowolnym momencie”.
              </p>
            </div>
          </div>
          <div class="row"></div>
        </div>
      </main>
    </div>
  </section>
</template>

<script>
import PageTitle from "../components/PageTitle";
export default {
  name: "About",
  components: {
    PageTitle,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
